import React from 'react'
import {Lang} from 'yougile-lang'
import {Time} from 'yougile-util'
import {
  DataObjectPropertiesValue,
  DealActivityMovedItem,
  isDataObjectId
} from 'yougile-model'
import {Sync} from '@client/sync'
import {Icon} from '@components/common/base/icon'
import {TwMessageContainer, TwMessageIcon} from './common'
import {DealTimeLineMessageProps} from './types'

export const DealTimeLineMovedMessage = (
  props: DealTimeLineMessageProps<DealActivityMovedItem>
) => {
  const {activity} = props

  return (
    <TwMessageContainer key={activity.id} $position="center">
      <TwMessageIcon>
        <Icon icon="EllipseSystemIcon" />
      </TwMessageIcon>
      <div className="text-14 text-primary pl-12">
        <span className="font-normal text-secondary">
          {Time.formatDateTime(activity.timestamp)}
        </span>
        <span className="font-normal ml-4">
          {Lang.msg.crm.rightPanel.dealHistory.dealMoved}:{' '}
        </span>
        <span className="font-semibold">
          {getHubTitle(activity.moved.from)} → {getHubTitle(activity.moved.to)}
        </span>
      </div>
    </TwMessageContainer>
  )
}

const getHubTitle = (hubId?: DataObjectPropertiesValue): string => {
  const box = Sync.getCurrentSandbox()
  if (!isDataObjectId(hubId)) {
    return ''
  }

  return box.getHub(hubId)?.title ?? ''
}
